import { connect } from 'react-redux';
import App from './App';

const mapStateToProps = state => ({
  currentApp: state.app.current,
});

export default connect(mapStateToProps)(App);
